import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { Workflow, WorkflowBase } from '@devices/models';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  private http = inject(HttpClient);
  getWorkflows(deviceId: string, params: Record<string, string | boolean | number> = {}) {
    return firstValueFrom(this.http.get<{ count: number; data: Workflow[]; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/workflows`,
      { params },
    ));
  }

  createWorkflow(deviceId: string, body: WorkflowBase) {
    return firstValueFrom(this.http.post<{ data: Workflow; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/workflows`,
      body,
    )
      .pipe(map(response => response.data)));
  }

  updateWorkflow({ deviceId, body, workflowId }: { body: Partial<Workflow>; deviceId: string; workflowId: string; }) {
    return firstValueFrom(
      this.http.patch<{ data: Workflow; }>(
        `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/workflows/${workflowId}`,
        body,
      )
        .pipe(map(response => response.data)),
    );
  }

  deleteWorkflow(deviceId: string, workflowId: string) {
    return firstValueFrom(this.http.delete(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${deviceId}/workflows/${workflowId}`,
    ));
  }
}
